import { TFunction } from "i18next";
import * as yup from "yup";

export interface EnrollmentConditionValidationSchemeProps {
  t: TFunction;
}

export const EnrollmentConditionValidationScheme = ({
  t,
}: EnrollmentConditionValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
      name: yup.string().required(requiredMsg)
  });;
};